/** Помошник, который обрабатывает результат SPARQL запроса, для отображения в графе.
 * Обеспечивает формироание секций header, class, classAttribute, property и propertyAttribute
 * 
 * Пример использование логеров
 * {"defaultLanguage": "ru", "logger": ["SkipCreateType_AS_NONE", "NotSupportedType_AS_NONE"]}
 * SkipCreateLink_AS_ХХХХ - отображать в console проблему создания связи как 
 *   SkipCreateLink_AS_ERROR - console.error(...)
 *   SkipCreateLink_AS_WARN  - console.warn(...)
 *   SkipCreateLink_AS_LOG - console.log(...)
 *   SkipCreateLink_AS_NONE - не показывать сообщение
 * CreateLinkLog - отображать в консоле, какая создаётся связь 
 * 
 * расширенная опция "predicatInCheckIsLinkCreate":true
 * указывает, что должно использоваться значение предиката, для создания связи между субъектом и объектом
 * Пример задания {"predicatInCheckIsLinkCreate":true, "logger":[], "rangeNodeForLinkCreate": true},
 * 
 * 
 * Пример задания декаратора по атрибуту
 * "decorators": [{"pattern": {"attribute": "http://cpgu.kbpm.ru/ns/rm/rdf#artifactFormat", "value": "http://cpgu.kbpm.ru/ns/rm/user-types#_YwcOsRmREemK5LEaKhoOow_Module"},"decor":{"backgroundColor": "#AAFF00"}}]
 */

//const typesFilter = ["http://voc.hbz.ru/TesaurusConcept", "http://voc.hbz.ru/MicroTesaurus", "http://voc.hbz.ru/schema#Domain"];
//const labelsFilter = ["http://www.w3.org/2004/02/skos/core#prefLabel", "http://www.w3.org/2000/01/rdf-schema#label"];
//const linksFilter = ["http://www.w3.org/2004/02/skos/core#broader", "http://www.w3.org/2004/02/skos/core#topConceptOf", "http://voc.hbz.ru/schema#domain"]
const typesFilter = [];
const labelsFilter = [];
const linksFilter = []
const _comment = "Создано приложением для семантической интеграции (версия 0.7.0), http://csi.semanticpro.org";

const header= { 
  "languages" : [ "ru", "undefined" ],
  "baseIris" : [ "http://voc.hbz.ru/", "http://voc.hbz.ru/schema#", "http://www.w3.org/1999/02/22-rdf-syntax-ns", "http://www.w3.org/2000/01/rdf-schema", "http://www.w3.org/2001/XMLSchema", "http://www.w3.org/2004/02/skos/core" ],
  "prefixList" : {
    "owl" : "http://www.w3.org/2002/07/owl#",
    "rdf" : "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "terms" : "http://purl.org/dc/terms/",
    "skos" : "http://www.w3.org/2004/02/skos/core#",
    "xsd" : "http://www.w3.org/2001/XMLSchema#",
    "dc" : "http://purl.org/dc/elements/1.1/",
    "xml" : "http://www.w3.org/XML/1998/namespace",
    "dct" : "http://purl.org/dc/terms/",
    "rdfs" : "http://www.w3.org/2000/01/rdf-schema#",
    "vhbz" : "http://voc.hbz.ru/",
    "svhbz": "http://voc.hbz.ru/schema#"
  },
  "iri" : "http://hbz.ru/ontologies/emd/",
  "labels" : { "undefined" : "Тезаурурс ГИС ХББ" },
  title: "Тезаурурс ГИС ХББ"
}

const nodesDecorator = [
  {p: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type", o: "http://voc.hbz.ru/schema#Domain", backgroundColor: "#FFFF00"},
  {p: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type", o: "http://voc.hbz.ru/MicroTesaurus", backgroundColor: "#00FF00"},
]
const nodesBgroundColor={"http://voc.hbz.ru/schema#Domain": "#FFFF00", "http://voc.hbz.ru/MicroTesaurus": "#00FF00"};

/** Помогает парсировать результаты SPARQL запроса */
module.exports = function (response) {
  var helper = {},
	    vars = (response)?response.head.vars:[],
      data = (response)?response.results.bindings:[],
      conversionSettings={},  //Настройки преобразования owl в vowl
      //Элементы заголовка, заполняемые в ходе парсинга
      //iri определяется по o.value д.б. http://www.w3.org/2002/07/owl#Ontology
      //соответственно заполняется title и description
      header={languages:["undefined"], baseIris:[], iri:"", title:{}}, 
      namespaces= [],
      classes= [],
      classAttributes=[],
      properties=[],
      propertyAttributes= [],
      idClasses={}, // Идентификатор: IRI класса
      classIds={}, // IRI класса: идентификатор
      nodes=[],     //Служебный массив, из которого формируется classes и properties
      nodeAttributes=[],  //Служебный массив, из которого формируется classAttributes и propertyAttributes
      idNodes={},   // Идентификатор: IRI класса или свойства (по id (индекс массива nodes или nodesProperties) получить IRI
      nodeIds={},   // IRI: идентификатор (по IRI получить id (индекс массива nodes или nodesProperties))
      singleThing=null, //Идентификатор http://www.w3.org/2002/07/owl#Thing для элементов не имеющих привязки ни к одному из классов, например объявленные объектные свойства
      things=[],    // Служебный массив http://www.w3.org/2002/07/owl#Thing параметромами является id - узла, single является ли он single
      unknown={},   //Данные, которые не понятно к чему отнести, т.к. у них нет http://www.w3.org/1999/02/22-rdf-syntax-ns#type	или они относятся к не обрабатываемы элементам
      individuals={},   //Список элементов имеющих тип http://www.w3.org/2002/07/owl#NamedIndividual
      bnodes={},    //Анонимные узлы. Используются для расширенного представление свойств у классов и индивидуалов
      statistics={lang:[]}, //Статистика найденных элементов, для настройки header
      decorators=[]; //Дополнительные декораторы
      
  helper.setResponse=function (response){
    //console.log("helper.setResponse=function (response)", response);
    //console.log(response.head.vars);
    //console.log(response.results.bindings);
    vars = (response)?response.head.vars:[],
    data = (response)?response.results.bindings:[],
    conversionSettings = {},
    namespaces= [],
    classes= [],
    classAttributes=[],
    properties=[],
    propertyAttributes= [],
    idClasses={}, // Идентификатор: IRI класса
    classIds={}, // IRI класса: идентификатор
    nodes=[], 
    nodeAttributes=[],
    idNodes={}, 
    nodeIds={}, 
    singleThing=null,
    things=[],
    unknown={},
    individuals={},
    bnodes={},
    statistics={lang:[]}; //Статистика найденных элементов, для настройки header
  }

  helper.setConversionSettings=function(settings){
    //console.log("sparqlHelper.js  helper.setConversionSettings", settings);
    conversionSettings = (settings)?JSON.parse(JSON.stringify(settings)):{};
    //Обрабатываем логирование, т.к. логирование может быть в extra_options
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.logger){
      conversionSettings.logger = conversionSettings.settings.extra_options.logger;
    }    
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.decorators)
      decorators = conversionSettings.settings.extra_options.decorators;
  }

  function empty(){
    header={languages:["undefined"], baseIris:[], iri:"", title:{}}, namespaces=[], 
    classes= [], classAttributes=[], properties=[], propertyAttributes= [], 
    nodes=[], nodeAttributes=[], idNodes={}, nodeIds={}, singleThing=null, things=[], unknown={},
    individuals={}, bnodes={}, statistics={lang:[]};
  }

  helper.getClasses=function(){
    if ((classes.length<1) && (data.length>0)) 
      TRIPLETS2VOWL();
		return classes;
  };
  
  parseIRI_lastSection=function(iri){
    if (iri){
      if (iri.lastIndexOf('#')>0) return iri.substring(iri.lastIndexOf('#')+1);
      if (iri.lastIndexOf('/')>0) return iri.substring(iri.lastIndexOf('/')+1);
    }
    return iri;
  }

  helper.getClassAttributes=function(){
    return classAttributes;
  }

  helper.getProperties=function(){
    //Текущие значения узлов. Нужно для получения classIds при связи узлов
    if ((properties.length<1) && (data.length>0)){
      TRIPLETS2VOWL();
    }
		return properties;
  };

  helper.getPropertyAttributes=function(){
    return propertyAttributes;
  }

  /** Обновление визуального представления
   * TODO сделать массив декараторов в element, когда он формируется (будут убраны лишнии циклы)
   */
  helper.updateDecorator=function(node, element){
    if (element.rdfType){
      const decordByRdfType = decorators.filter(decor => decor.pattern["rdfType"] == element.rdfType);
      if (Array.isArray(decordByRdfType) && decordByRdfType.length>0){
        const bg = decordByRdfType[0].decor["backgroundColor"];
        if (bg) node.backgroundColor(bg);
      }
    }
    //Поищем для атрибутов
    if (element.attrs && Array.isArray(element.attrs) && element.attrs.length>0){
      const decordByAttrs = decorators.filter(decor => {
        const a = element.attrs.filter(attr => (attr.p.value==decor.pattern["attribute"]) && (attr.o.value==decor.pattern["value"]) );
        return (Array.isArray(a) && a.length>0)
      });
      if (Array.isArray(decordByAttrs) && decordByAttrs.length>0){
        const bg = decordByAttrs[0].decor["backgroundColor"];
        if (bg) node.backgroundColor(bg);
      } 
    }
    
  // if (element.rdfType){
    //   const bg = nodesBgroundColor[element.rdfType];
    //   if (bg) node.backgroundColor(bg);
    // }
    console.log("sparqlHelper.js helper.updateDecorator", node, element, decorators);
  }
  
  helper.getTitle = function(){
    return header.title;
  }

  helper.getHeader = function(){
    return header;
  }

  helper.getNamespaces=function(){
    return namespaces;
  }

  helper.getData = function (){
    return {_comment, header, head: {vars}, results: {bindings:data}};
  }

  /** Функция формирует значение языка для аннотирующего или дата проперти. По умолчанию возвращает "undefined" */
  function makeLang(o){
    //Создадим статистику использования языков
    const lang = (o && o["xml:lang"])? o["xml:lang"]: "undefined";
    if (typeof statistics.lang[lang] === 'undefined') 
        statistics.lang[lang] = {name: lang, count: 0};
    statistics.lang[lang].count = statistics.lang[lang].count + 1;
    return lang;
  }
  
  /** Значение предиката соответствует парметру uri и type=uri */
  function isURI(predicat, uri, type="uri"){
    return (predicat && (predicat.type==type))? predicat.value == uri: false;
  }

  /** Значение предиката соответствует парметру uri */
  function isValue(predicat, value){
    return (predicat)? predicat.value == value: false;
  }

  /**
   * Функция конвертирующая содержимое онтологии (представлены в виде триплетов) в VOWL.
   * Функция заполняет секции classes, classAttributes, properties и propertyAttributes
   * Общая схема заполнения:
   * 1. Формируются classes и properties (используются триплеты, у которых предикат http://www.w3.org/1999/02/22-rdf-syntax-ns#type) 
   * с частичным заполнением classAttributes и propertyAttributes.
   * 2.
   */
  function TRIPLETS2VOWL(){
    empty();
    console.log("sparqlHelper.js TRIPLETS2VOWL", conversionSettings);
    //Определим все классы, как элементы имеющие предикат 
    idClasses = {};
    classAttributes = [];
    //Специальный массив, который содержит все триплеты у которых предикат "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
    const types = data.filter(item => isURI(item.p, "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"));
    const items = types.filter(item => (
        item.o && (item.o.type=="uri") && (typesFilter.includes(item.o.value) || checkIsTypeCreate(item.o, item.s))
      ));
    //Определим супер типы, которые отсутствуют как узлы в items
    if (checkIsTypeAsSuperClass()){
      const superTypes = new Set(); //Список супер типов
      for (let i = 0; i < types.length; i++) {
        const item = types[i];
        superTypes.add(item.o.value);
      }
      //console.log("111111111111",[...superTypes]);
    }
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      idClasses[i]=item.s.value; 
      classIds[item.s.value]=i;
      classes.push({"id": i, "type": "owl:Class"})
      classAttributes.push({iri: item.s.value, id: i, attrs:[], "label": {"undefined": "????"}, "rdfType":item.o.value});
    }
    //Заполним класс их свойствами
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      let index = (item.s && item.s.type=="uri")? classIds[item.s.value]: null;
      if (index != null) {
        classAttributes[index].attrs.push({p: item.p, o: item.o});
      }
    };
    for (let i = 0; i < classAttributes.length; i++) {
      const item = classAttributes[i];
      //Заполним метками
      const labels = item.attrs.filter(attr=> ( attr.p && (attr.p.type=="uri") && (checkIsLabelNodes(attr.p))))
        .map(attr =>{
          {
            let label = {lang: "undefined"};
            if (attr.o["xml:lang"]) label["lang"] = attr.o["xml:lang"];
            label["value"] = attr.o.value;
            return label;
          }
        });
      classAttributes[i].label = {};
      classAttributes[i].label["IRI-based"] = parseIRI_lastSection(classAttributes[i].iri);
      if (labels.length>0) {
          labels.map(label => classAttributes[i].label[label.lang] = label.value);
          if (labels.filter(label => label.lang=="undefined").length<1);
            classAttributes[i].label["undefined"] = labels[0].value;
        };
      //Заполним аннотирующие свойства
      const annotations = item.attrs.filter(attr=> ( attr.p && (attr.p.type=="uri") && (!labelsFilter.includes(attr.p.value))));
      if (annotations.length>0)
        classAttributes[i].annotations = {};
      for (let j = 0; j < annotations.length; j++) {
        const a = annotations[j];
        const id = parseIRI_lastSection(a.p.value);
        if (!Array.isArray(classAttributes[i].annotations[id]))
          classAttributes[i].annotations[id] = [];
        const values = {"identifier": id, type: a.o.type, value: a.o.value, language: "undefined"};
        if (a.o["xml:lang"]) values.language = a.o["xml:lang"];
        if (values.type=="uri") values.type="iri";
        classAttributes[i].annotations[id][classAttributes[i].annotations[id].length] = values;
      }
    }

    //Определим все связи, как элементы имеющие определённый предикат 
    const links = data.filter(item => (item.p && (item.p.type=="uri") && item.o && (item.o.type=="uri") && item.o && (item.o.type=="uri") && checkIsLinkCreate(item)));
    console.log("sparqlHelper.js TRIPLETS2VOWL links", JSON.stringify(links));
    for (let i = 0; i < links.length; i++) {
            const link = links[i];
            const domain = classIds[link.s.value];
            let range = classIds[link.o.value];
            //Создадим узел для случая, что отсутствует range
            if (isRangeNodeForLinkCreate() && (range == null)){
              const index = data.length+i;
              idClasses[index]=link.o.value; 
              classIds[link.o.value]=index;
              classes.push({"id": index, "type": "owl:Class"})
              classAttributes.push({iri: link.o.value, id: index, attrs:[], "label": {"undefined": parseIRI_lastSection(link.o.value)}, "rdfType":link.o.value});
              vowlIncludeInAttributes(classAttributes.length-1, "external");
              range = index;
            }
            if ((domain == null) || (range == null)){
              console.warn("Link parse. No range or domain", link, domain, range);
            } else {
              properties.push({"id": i, "type": "owl:objectProperty"});
              propertyAttributes.push({range: range.toString(), id: i, domain: domain.toString(), 
                "attributes" : [ "object", "anonymous" ], label: {"IRI-based": parseIRI_lastSection(link.p.value)}});
            }
    }
          //console.log("properties", properties, propertyAttributes);
    makeHeader()
    //console.log("items", classes, classAttributes);
  }

  /** Заполняет значение заголовка */
  function makeHeader(){
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.legend){
      header.legend = conversionSettings.settings.extra_options.legend;
    }    
  }
  /** Добавляет в classAttribute в attributes значение value. id - индекс элемента в attributes  */
  function vowlIncludeInAttributes(id, value){
    if (!Array.isArray(classAttributes[id].attributes)) classAttributes[id]["attributes"] = [];
    if (!classAttributes[id].attributes.includes(value)) 
    classAttributes[id].attributes.push(value)
  }
  /** Проверяет, что используется для создания узла. True - создавать */
  function checkIsTypeCreate(o, s){ 
    if (conversionSettings && conversionSettings.settings && Array.isArray(conversionSettings.settings.createTypes)){
      if (conversionSettings.settings.createTypes.includes(o.value))
       return true;
    }
    if (conversionSettings && Array.isArray(conversionSettings.logger)){
      if (conversionSettings.logger.includes("SkipCreateType_AS_ERROR"))
        console.error("Skip create triplet2vowl type ", o, s, conversionSettings)
      else
        if (conversionSettings.logger.includes("SkipCreateType_AS_WARN"))
          console.warn("Skip create triplet2vowl type ", o, s, conversionSettings)
        else 
          if (conversionSettings.logger.includes("SkipCreateType_AS_LOG"))
            console.log("Skip create triplet2vowl type ", o, s, conversionSettings)
    }else {
      console.warn("Skip create triplet2vowl type ", o, s, conversionSettings);
    }      
    return false;
  }

  /** Проверяет, что тип, определяет наследование субъекта. Т.е. объект и субъект имеют отношение генерализации */
  function checkIsTypeAsSuperClass(){
    return (conversionSettings && conversionSettings.settings && conversionSettings.settings.typeAsSuperClass)? true: false;
  }

  /** Проверяет, что используется для создания связи. True - создавать */
  function checkIsLinkCreate(item){ 
    if (conversionSettings && conversionSettings.settings && Array.isArray(conversionSettings.settings.linksFilter)){
      if (conversionSettings.settings.linksFilter.includes(item.p.value)){
        if (conversionSettings && Array.isArray(conversionSettings.logger)){
          if (conversionSettings.logger.includes("CreateLinkLog"))
            console.log("Create triplet2vowl link ", item, conversionSettings)
        }
        return true;
      }
    }
    if (conversionSettings && Array.isArray(conversionSettings.logger)){
      if (conversionSettings.logger.includes("SkipCreateLink_AS_ERROR"))
        console.error("Skip create triplet2vowl link ", item, conversionSettings)
      else
        if (conversionSettings.logger.includes("SkipCreateLink_AS_WARN"))
          console.warn("Skip create triplet2vowl link ", item, conversionSettings)
        else 
          if (conversionSettings.logger.includes("SkipCreateLink_AS_LOG"))
            console.log("Skip create triplet2vowl link ", item, conversionSettings)
    }else {
      console.warn("Skip create triplet2vowl link ", item, conversionSettings);
    }      
    return false;
  }

  /** Проверяет, что используется для формирования метки */
  function checkIsLabelNodes(p){
    if (conversionSettings && conversionSettings.settings && Array.isArray(conversionSettings.settings.labelNodes)){
      if (conversionSettings.settings.labelNodes.includes(p.value)){
        return true;
      }
    }
    return false;
  }
  /** Проверяет значение флага, что значение предиката используется для назначения связи */
  function isPredicatInCheckIsLinkCreate(){
      return conversionSettings && conversionSettings.settings && conversionSettings.settings.extra_options
         && conversionSettings.settings.extra_options.predicatInCheckIsLinkCreate;
  }

  /** Проверяет значение флага, что создать внешний узел для случая когда нет более верхнего узла */
  function isRangeNodeForLinkCreate(){
    return conversionSettings && conversionSettings.settings && conversionSettings.settings.extra_options
       && conversionSettings.settings.extra_options.rangeNodeForLinkCreate;
  }

  return helper;

};